(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-shop-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Copy the bar's shop items (not the main-menu links, which the drawer already has) to the top of the hamburger drawer.
    var bar = document.querySelector('.ra-shopmenu__list');
    var drawerNav = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (bar && drawerNav && !drawerNav.querySelector('.ra-drawer-shop')) {
      var list = document.createElement('ul');
      list.className = 'ra-drawer-shop';
      list.setAttribute('role', 'list');
      bar.querySelectorAll(':scope > .ra-shopmenu__item:not(.ra-shopmenu__item--desktop)').forEach(function (item) {
        var copy = item.cloneNode(true);
        copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        list.appendChild(copy);
      });
      // Hide main-menu entries in the drawer that are already in the copied shop links.
      var hidden = (bar.closest('nav').getAttribute('data-hide-sep') || '').split('|').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
      var shopPaths = Array.prototype.map.call(list.querySelectorAll(':scope > li > a[href]'), function (a) { return a.pathname; });
      drawerNav.querySelectorAll('.menu-drawer__menu > li > a[href]').forEach(function (a) {
        var title = a.textContent.trim().toLowerCase();
        if (shopPaths.indexOf(a.pathname) !== -1 || hidden.indexOf(title) !== -1) a.parentElement.hidden = true;
      });
      drawerNav.prepend(list);
    }

    // Keep --ra-header-h equal to the sticky header's height (it changes as the logo shrinks on scroll).
    var headerSection = document.querySelector('.section-header');
    if (headerSection && 'ResizeObserver' in window) {
      var setHeaderH = function () {
        var sticky = getComputedStyle(headerSection).position === 'sticky' && !headerSection.classList.contains('shopify-section-header-hidden');
        document.documentElement.style.setProperty('--ra-header-h', (sticky ? headerSection.offsetHeight : 0) + 'px');
      };
      new ResizeObserver(setHeaderH).observe(headerSection);
      new MutationObserver(setHeaderH).observe(headerSection, { attributes: true, attributeFilter: ['class'] });
      setHeaderH();
    }

    var hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    // Hover intent: a menu stays open briefly after the pointer leaves, so moving diagonally
    // down into the panel (possibly across another menu name) doesn't close it.
    var CLOSE_DELAY = 600;
    var SWITCH_DELAY = 250;
    var barMenus = Array.prototype.slice.call(document.querySelectorAll('nav.ra-shopmenu .ra-shopmenu__details'));
    function openOnly(target) {
      barMenus.forEach(function (d) { if (d !== target) d.open = false; });
      target.open = true;
    }
    document.querySelectorAll('.ra-shopmenu__details').forEach(function (details) {
      var item = details.closest('.ra-shopmenu__item');
      var isBar = barMenus.indexOf(details) !== -1;
      var closeTimer;
      var openTimer;
      if (isBar) {
        item.addEventListener('mouseenter', function () {
          if (!hoverQuery.matches) return;
          clearTimeout(closeTimer);
          if (details.open) return;
          var otherOpen = barMenus.some(function (d) { return d !== details && d.open; });
          // Switching from another open menu waits a moment, so just passing over this name doesn't steal focus.
          openTimer = setTimeout(function () { openOnly(details); }, otherOpen ? SWITCH_DELAY : 0);
        });
        item.addEventListener('mouseleave', function () {
          if (!hoverQuery.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { details.open = false; }, CLOSE_DELAY);
        });
        // Hover already opened it, so a click on the name must not toggle it shut again.
        details.querySelector('summary').addEventListener('click', function (e) {
          if (!hoverQuery.matches) return;
          e.preventDefault();
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
          openOnly(details);
        });
      }
      document.addEventListener('click', function (e) {
        if (details.open && !details.contains(e.target)) details.open = false;
      });
      details.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
    });
  })();

  // Tabs inside the menu panels (also works for the copies in the phone drawer).
  (function () {
    function selectTab(tab) {
      var root = tab.closest('[data-ra-tabs]');
      if (!root) return;
      var id = tab.getAttribute('data-ra-tab');
      root.querySelectorAll('[data-ra-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      root.querySelectorAll('[data-ra-tabpanel]').forEach(function (p) { p.hidden = p.getAttribute('data-ra-tabpanel') !== id; });
    }
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ra-tab]');
      if (tab) selectTab(tab);
    });
    // On desktop, hovering a Single Miniatures tab switches to it (character-select feel).
    var hoverTabs = window.matchMedia('(hover: hover) and (min-width: 990px)');
    document.addEventListener('mouseover', function (e) {
      if (!hoverTabs.matches) return;
      var tab = e.target.closest('.ra-mm__tab');
      if (tab && tab.getAttribute('aria-selected') !== 'true') selectTab(tab);
    });
    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-ra-tab]');
      if (!tab || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
      var tabs = Array.prototype.slice.call(tab.parentElement.querySelectorAll('[data-ra-tab]'));
      var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
      var next = tabs[(i + tabs.length) % tabs.length];
      next.focus();
      selectTab(next);
      e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
